import getInstance from "../config/api";

export default class Access {
  static async fetchAccessConsolidated(params) {
    const instance = getInstance();
    const { data } = await instance.get(`/request/grouped`, { params });
    return data;
  }

  static async fetchTotalAccessConsolidated(params) {
    const instance = getInstance();
    const { data } = await instance.get(`/request/grouped-all`, { params });
    return data;
  }

  static async downloadAccessPerClientConsolidated(params) {
    const instance = getInstance();
    const data = await instance.get("/request/grouped-csv", { params });
    return data;
  }

  static async downloadTotalAccessConsolidated(params) {
    const instance = getInstance();
    const data = await instance.get("/request/grouped-all-csv", { params });
    return data;
  }
}
